import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Wrench } from 'lucide-react';

/**
 * Points from an evening to the tool that does the same work and keeps what
 * the reader writes, in place of a written exercise that repeats the tool.
 *
 * Block shape: { type: 'toolLink', toolId, title, text }
 */
const ToolLink = ({ toolId, title, text }) => (
  <Link
    to={`/toolkit/${toolId}`}
    className="my-6 flex items-center gap-4 rounded-2xl border border-courtyard-gold/40 bg-gradient-to-br from-courtyard-parchment to-white p-5 shadow-sm hover:border-courtyard-clay/60 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-courtyard-clay"
  >
    <span className="w-10 h-10 rounded-xl bg-courtyard-terracotta/15 flex items-center justify-center flex-shrink-0">
      <Wrench className="w-5 h-5 text-courtyard-clay" aria-hidden="true" />
    </span>
    <span className="flex-1">
      <span className="block text-xs font-bold uppercase tracking-wider text-courtyard-clay">In the toolkit</span>
      <span className="block font-display font-bold text-courtyard-stone">{title}</span>
      {text && <span className="block text-[15px] text-courtyard-stone/80 leading-relaxed mt-0.5">{text}</span>}
    </span>
    <ArrowRight className="w-5 h-5 text-courtyard-clay flex-shrink-0" aria-hidden="true" />
  </Link>
);

export default ToolLink;
